import React from 'react';
import { useTranslation } from 'react-i18next';
import isNil from 'lodash/isNil';
import { selectUser } from 'state/selectors';
import { ShapeVariant, SizeVariant } from 'ui/components/ControlButton/types';
import { StartRecordButtonBase, StartRecordIcon } from './view';

interface StartRecordButtonProps {
    onClick(): void;
    buttonShape?: ShapeVariant;
    buttonSize?: SizeVariant;
}

export const StartRecordButton = ({ onClick, buttonShape, buttonSize }: StartRecordButtonProps) => {
    const { t } = useTranslation();
    const user = selectUser();
    const isUserInfoExists = !isNil(user);

    if (!isUserInfoExists) return null;

    return (
        <StartRecordButtonBase
            title={t('web_call_record_tooltip_video_start')}
            onClick={onClick}
            shape={buttonShape}
            size={buttonSize}
        >
            <StartRecordIcon icon="icRecord" color="none" size={24} />
        </StartRecordButtonBase>
    );
};
